import { initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_API_URL,
  databaseURL: process.env.REACT_APP_DB_URL,
  projectId: "my-trading-monitor",
  storageBucket: "my-trading-monitor.appspot.com",
  messagingSenderId: "402743970497",
  appId: "1:402743970497:web:7d8e1b963ae9a1ecde2240",
  measurementId: "G-JRDK03HVS2",
};

export const app = initializeApp(firebaseConfig);
